import type { RibbonControlGroupDefinitionMLR, RibbonTabDefinitionBase } from "owa-acui";
import { owaComputedFn } from "owa-computed-fn";
import { constructKeytip, Multiline } from "owa-command-ribbon";
import loc from "owa-localize";
import { getMailRibbonConfigStore } from "owa-mail-ribbon-store/lib/store/store";
import { send_receive_tab as Strings_send_receive_tab } from "owa-mail-ribbon-utils/lib/ribbon_mail_strings.locstring.json";
import type { ReadOnlyRibbonControlDefProps } from "owa-mail-ribbon-utils";
import { getUniqueTabId } from "owa-mail-ribbon-utils/lib/getUniqueTabId";
import { type MailRibbonTabId } from "owa-ribbon-ids/lib/mailRibbonId";
import { getMLRTabGroups } from "../../../util/getTabGroups";
import { getMLRSendReceiveTabCommonGroupFlyout } from "./getMLRSendReceiveTabCommonGroupFlyout";
import { getMLRSendReceiveTabControlDefinition } from "./getMLRSendReceiveTabControlDefinition";
import { getMLRSendReceiveTabGroupLayouts } from "./getMLRSendReceiveTabGroupLayouts";

const getMLRSendReceiveTab: (props: ReadOnlyRibbonControlDefProps) => RibbonTabDefinitionBase | undefined = owaComputedFn(function getMLRSendReceiveTab(props: ReadOnlyRibbonControlDefProps): RibbonTabDefinitionBase | undefined {
    const groups = getSendReceiveTabGroups(props);
    if (groups.length === 0) {
        return undefined;
    }
    
    return {
        type: Multiline,
        id: getUniqueTabId(16, undefined /* editorId */, props.itemId, props.isPopout),
        title: loc(Strings_send_receive_tab),
        controlGroups: { type: Multiline, groups },
        initialScalingSteps: [],
        scalingSteps: [],
        keytipProps: constructKeytip([], 16, true /* hasMenu */),
    };
});

const getSendReceiveTabGroups: (props: ReadOnlyRibbonControlDefProps) => RibbonControlGroupDefinitionMLR[] = owaComputedFn(function getSendReceiveTabGroups(props: ReadOnlyRibbonControlDefProps): RibbonControlGroupDefinitionMLR[] {
    let sendReceiveTabGroups: RibbonControlGroupDefinitionMLR[] = new Array();
    sendReceiveTabGroups = getMLRTabGroups(16, getMailRibbonConfigStore(props.mailboxInfo).multiline.sendReceiveTab.layout, getMLRSendReceiveTabControlDefinition, getMLRSendReceiveTabGroupLayouts, getMLRSendReceiveTabCommonGroupFlyout, props);
    
    return sendReceiveTabGroups;
});

export default getMLRSendReceiveTab;
